import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {ColorSchemeDataModel} from '../../../models/configuration/color-scheme-data.model';

@Injectable({
  providedIn: 'root'
})
export class ColorSchemesService {
  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any) => {
      console.error(error);
      return of(result as T);
    };
  }

  getColorSchemes(skipCache : boolean = false): Observable<ColorSchemeDataModel[]> {
    return this.http.get<ColorSchemeDataModel>(`/api/Theme?`+ (skipCache ? Date.now() : '') )
      .pipe(catchError(this.handleError<any>('GetdataColorSchemes')));
  }

  getColorScheme(guid: string): Observable<ColorSchemeDataModel> {
    return this.http.get<ColorSchemeDataModel>(`/api/Theme/${guid}`)
      .pipe(catchError(this.handleError<any>('GetdataColorScheme')));
  }

  saveColorScheme(selectedColorSchemeData: ColorSchemeDataModel, isNew: boolean): Observable<void> {
    console.log('selectedColorSchemeData', selectedColorSchemeData);
    if (isNew) {
      return this.http.post<any>(`/api/Theme/PostdataColorScheme`, selectedColorSchemeData)
        .pipe(catchError(this.handleError<any>('callPostdataColorScheme')));
    } else {
      return this.http.put<void>(`/api/Theme/PutdataColorScheme`, selectedColorSchemeData)
        .pipe(catchError(this.handleError<any>('callPostdataColorScheme')));
    }
  }

  deleteColorScheme(guid: string): Observable<any> {
    return this.http.post<any>(`/api/Theme/RemoveColorScheme/${guid}`, {})
      .pipe(catchError(this.handleError<any>('callRemoveColorScheme')));
  }
}
